export default "__VITE_PUBLIC_ASSET__332506ea__"